import React from "react";

const ProjectCustomFieldEmbed = ({ customFields, customGroupsValues, setCustomGroupsValues }) => {
    // Filtrar grupos que contienen 'ante' o 'proyecto' en el nombre
    const filteredGroups = customFields.filter(group =>
        /ante/i.test(group.group_name) && /proyecto/i.test(group.group_name)
    );

    // Obtener valor actual de un campo
    const getFieldValue = (groupId, fieldId) => {
        const groupEntry = customGroupsValues.find(entry => entry.groupId === groupId);
        return groupEntry?.values?.[fieldId] ?? "";
    };

    // Actualizar valor de un campo
    const updateFieldValue = (groupId, fieldId, value) => {
        setCustomGroupsValues(prev =>
            prev.map(entry =>
                entry.groupId === groupId
                    ? {
                        ...entry,
                        values: {
                            ...entry.values,
                            [fieldId]: value,
                        },
                    }
                    : entry
            )
        );
    };

    return (
        <>
            {filteredGroups.map(group => (
                <div key={group.id} className="form-group mt-4">
                    {/*<h5 className="mb-3">{group.group_name}</h5>*/}
                    {group.custom_fields?.map(field => {
                        const value = getFieldValue(group.id, field.id);

                        switch (field.field_type) {
                            case "text":
                            case "number":
                            case "date":
                                return (
                                    <div className="mb-3" key={field.id}>
                                        <label className="form-label">{field.field_name}</label>
                                        <input
                                            type={field.field_type}
                                            className="form-control"
                                            value={value}
                                            onChange={(e) =>
                                                updateFieldValue(group.id, field.id, e.target.value)
                                            }
                                        />
                                    </div>
                                );
                            case "textarea":
                                return (
                                    <div className="mb-3" key={field.id}>
                                        <label className="form-label">{field.field_name}</label>
                                        <textarea
                                            className="form-control"
                                            rows={3}
                                            value={value}
                                            onChange={(e) =>
                                                updateFieldValue(group.id, field.id, e.target.value)
                                            }
                                        />
                                    </div>
                                );
                            case "checkbox":
                                return (
                                    <div className="form-check mb-3" key={field.id}>
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id={`field-${field.id}`}
                                            checked={!!value}
                                            onChange={(e) =>
                                                updateFieldValue(group.id, field.id, e.target.checked)
                                            }
                                        />
                                        <label
                                            htmlFor={`field-${field.id}`}
                                            className="form-check-label"
                                        >
                                            {field.field_name}
                                        </label>
                                    </div>
                                );
                            case "select":
                                let options = [];
                                try {
                                    options = JSON.parse(field.option_list);
                                } catch {}

                                return (
                                    <div className="mb-3" key={field.id}>
                                        <label className="form-label">{field.field_name}</label>
                                        <select
                                            className="form-select"
                                            value={value}
                                            onChange={(e) =>
                                                updateFieldValue(group.id, field.id, e.target.value)
                                            }
                                        >
                                            <option value="">Seleccione una opción</option>
                                            {options.map((opt) => (
                                                <option key={opt} value={opt}>
                                                    {opt}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                );
                            case "select_multiple":
                                let multiOptions = [];
                                try {
                                    multiOptions = JSON.parse(field.option_list);
                                } catch {}

                                return (
                                    <div className="mb-3" key={field.id}>
                                        <label className="form-label d-block mb-2">{field.field_name}</label>
                                        {multiOptions.map((opt) => (
                                            <div className="form-check form-switch" key={opt}>
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id={`field-${field.id}-${opt}`}
                                                    checked={Array.isArray(value) && value.includes(opt)}
                                                    onChange={(e) => {
                                                        let newValue = Array.isArray(value) ? [...value] : [];

                                                        if (e.target.checked && !newValue.includes(opt)) {
                                                            newValue.push(opt);
                                                        } else if (!e.target.checked && newValue.includes(opt)) {
                                                            newValue = newValue.filter((v) => v !== opt);
                                                        }

                                                        const groupExists = customGroupsValues.some(entry => entry.groupId === group.id);
                                                        if (!groupExists) {
                                                            setCustomGroupsValues(prev => [
                                                                ...prev,
                                                                { groupId: group.id, values: { [field.id]: newValue } }
                                                            ]);
                                                        } else {
                                                            updateFieldValue(group.id, field.id, newValue);
                                                        }
                                                    }}

                                                />
                                                <label className="form-check-label" htmlFor={`field-${field.id}-${opt}`}>
                                                    {opt}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                );

                            default:
                                return null;
                        }
                    })}
                </div>
            ))}
        </>
    );
};

export default ProjectCustomFieldEmbed;
